import { Injectable } from '@angular/core';
import { ofType, Actions, createEffect } from '@ngrx/effects';
import { mergeMap, map, catchError, withLatestFrom } from 'rxjs/operators';
import { of } from 'rxjs';
import {
  VersionActionTypes,
  VersionErroredAction,
  VersionLoadedAction,
  VersionPageLoadedAction,
} from './version.action';
import { VersionService } from './version.service';
import { VersionApiError, VersionApiErrorTypes } from './version.errors';
import { getErrorType } from 'src/app/shared/utils/error.utils';
import { getProjectId } from '../router/router.selectors';
import { Store } from '@ngrx/store';

@Injectable()
export class VersionEffects {
  getVersionsList$ = createEffect(() =>
    this.actions$.pipe(
      ofType<ReturnType<typeof VersionPageLoadedAction>>(VersionActionTypes.VersionsPageLoaded),
      withLatestFrom(this.store.select(getProjectId)),
      mergeMap(([, projectId]) =>
        this.versionService.getVersionsList(projectId).pipe(
          map((versions) => VersionLoadedAction({ versions })),
          catchError((err) =>
            of(
              VersionErroredAction({
                error: new VersionApiError(getErrorType(VersionApiErrorTypes, err.status), err),
              }),
            ),
          ),
        ),
      ),
    ),
  );

  constructor(
    private actions$: Actions,
    private versionService: VersionService,
    private store: Store<any>,
  ) {}
}
